import React from "react";
import { FaCalendarAlt, FaUser, FaMapMarkerAlt } from "react-icons/fa";

const ArticleCard = () => {
  const articles = [
    {
      id: 1,
      image: "/article1.jpg", // Sample article image
      name: "The Future of Real Estate Development",
      updated: "January 10, 2025",
      author: "John Doe",
      location: "Mumbai",
    },
    {
      id: 2,
      image: "/article1.jpg", // Sample article image
      name: "Top Trends in Sustainable Housing",
      updated: "January 8, 2025",
      author: "Jane Smith",
      location: "Pune",
    },
    {
      id: 3,
      image: "/article1.jpg", // Sample article image
      name: "Exploring Smart Homes and IoT Integration",
      updated: "January 5, 2025",
      author: "Alex Johnson",
      location: "Bangalore",
    },
  ];

  return (
    <div className="p-6">
      <div className="flex flex-wrap gap-6 justify-center">
        {articles.map((article) => (
          <div
            key={article.id}
            className="relative bg-white shadow-md rounded-lg w-80 p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out"
          >
            <div
              className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
              style={{ backgroundColor: "#36A2EB" }}
            ></div>

            {/* Article Image */}
            <div className="rounded-lg overflow-hidden mb-4">
              <img
                src={article.image}
                alt={article.name}
                className="w-full h-52 object-cover"
              />
            </div>

            {/* Article Details */}
            <h2 className="text-lg font-bold text-gray-800 mb-2 text-center">{article.name}</h2>

            <div className="text-center mb-4 flex items-center justify-center text-gray-500">
              <FaCalendarAlt size={12} />
              <span className="ml-2 text-gray-600">{article.updated}</span>
            </div>

            {/* Author and Location */}
            <div className="flex flex-col justify-between items-center mb-4 gap-3">
              <div className="flex justify-center items-center bg-blue-100 text-blue-600 p-2 rounded-lg shadow-md gap-1">
                <FaUser size={12} />
                <span className="text-sm font-semibold">{article.author}</span>
              </div>

              <div className="flex justify-center items-center bg-green-100 text-green-600 p-2 rounded-lg shadow-md gap-1">
                <FaMapMarkerAlt size={12} />
                <span className="text-sm font-semibold">{article.location}</span>
              </div>
            </div>

            {/* Article Description */}
            <p className="text-sm text-gray-600 italic mb-4 text-center">
              Read this article to explore the latest trends and developments in the real estate sector.
            </p>

            {/* Buttons */}
            <div className="flex gap-4 mt-4">
              <button className="flex-1 bg-primaryOrange text-white text-sm font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition">
                Read Article
              </button>
              <button className="flex-1 bg-gray-100 text-gray-700 text-sm font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 hover:text-white transition">
                Share Article
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticleCard;
